import React from 'react';
import CompanyTabs from '../../Company/Tabs/CompanyTabs';
import CompanyVisitActionsTable from '../../VisitActions/Tables/CompanyVisitActionsTable';
import CompanyCommunicationsTable from '../../Communication/Tables/CompanyCommunicationsTable';
import CompanyPrimaryPeople from '../../Person/Components/CompanyPrimaryPeople';
import CompanyDetails from '../../Company/Components/CompanyDetails';
import CompanyPrimaryAddressesDetails from '../../Address/Components/CompanyPrimaryAddressesDetails';
import CompanyActions from '../../Company/Components/CompanyActions';
import CompanyProvider from '../../Company/Provider/CompanyProvider';
import CompanyPageTitleContent from '../../Company/Components/CompanyPageTitleContent';
import CompanyTitle from '../../Company/Components/CompanyTitle';
import CompanyIsLoadingSpinner from '../../Company/Components/CompanyIsLoadingSpinner';
import PageSection from '../../common/PageSection';
import RedirectNotLoggedIn from '../RedirectNotLoggedIn';
import { visitActionsQuery } from '../../../actions/Api/VisitAction/apiVisitActionsFilter';
import { apiUserLogPost } from '../../../actions/Api/User/apiUserLogPost';
import { apiMeetingFilter } from '../../../actions/Api/Meeting/apiMeetingFilter';
import Layout3Columns, { Column1, Column2, Column3 } from '../../Dashboard/Components/Layout3Columns';
import CompanyMeetingsTable from '../../Meeting/Tables/CompanyMeetingsTable';
import { apiCommunicationFilter } from '../../../actions/Api/Communication/apiCommunicationFilter';
import Next7DaysAgendaCard from '../../Calendar/Cards/Next7DaysAgendaCard';
import CompanyPromotionsAlerts from '../../Company/Components/CompanyPromotionsAlerts';
import { companyDataQuery } from '../../../actions/Api/Company/apiCompanyData';

export default ({
    location: { pathname },
    match: {
        params: { companyId: strCompanyId, companyName }
    },
    history
}) => {
    const companyId = parseInt(strCompanyId, 10);
    return (
        <CompanyProvider companyId={companyId}>
            <PageSection
                onBackClicked={history.goBack}
                title={<CompanyTitle />}
                titleExtra={<CompanyIsLoadingSpinner />}
                titleContent={<CompanyPageTitleContent />}
            >
                <RedirectNotLoggedIn
                    onLoggedInDispatchArray={[
                        companyDataQuery()
                            .forCompanyId(companyId)
                            .shouldFetchDemos(true)
                            .shouldFetchBandings(true)
                            .shouldFetchAgreements(true)
                            .shouldFetchOpportunities(true)
                            .run(),
                        visitActionsQuery()
                            .filterCompany(companyId)
                            .setFetchCompany(false)
                            .run(),
                        apiUserLogPost(companyName, 'Company', pathname),
                        apiMeetingFilter({ companyId }, false),
                        apiCommunicationFilter({ companyId })
                    ]}
                />
                <Layout3Columns>
                    <Column1>
                        <CompanyDetails hideCompanyName hideCompanyUcn />
                        <CompanyPrimaryPeople />
                        <CompanyPrimaryAddressesDetails />
                    </Column1>
                    <Column2>
                        <CompanyTabs />
                        <CompanyMeetingsTable />
                        <CompanyCommunicationsTable />
                        <CompanyVisitActionsTable />
                    </Column2>
                    <Column3>
                        <CompanyActions />
                        <CompanyPromotionsAlerts />
                        <Next7DaysAgendaCard
                            shouldFetchData={false}
                            companyId={companyId}
                            userId={undefined}
                            title="Upcoming"
                        />
                    </Column3>
                </Layout3Columns>
            </PageSection>
        </CompanyProvider>
    );
};
